import {
    IGameIdentityGoal,
    resourceNameGameIdentityGoal,
} from "motw_core/Entity/IGameIdentityGoal";
import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Data from "source/app/services/Data";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { IGameIdentityScoresState } from "../../GameIdentityScores";
import * as toastr from "toastr";
import { IGameIdentityDTO } from "../../../../../../../../motw_core/DTOs/IGameIdentityDTO";
import { IGoal } from "../../../../../../../../motw_core/Entity/IGoal";
import { ShowIdentityDetails } from "../Details/ShowIdentityDetails";
import { ArrayUtils } from "../../../../../services/ArrayUtils";

export function DeleteGoalLink({
    allGoals,
    gameIdentityGoal,
    identity,
    goalNamesLoggedToday,
}: {
    allGoals: IGoal[];
    gameIdentityGoal: IGameIdentityGoal;
    identity: IGameIdentityDTO;
    goalNamesLoggedToday: string[];
}) {
    return (
        <IconWithText
            iconSuffix={EGlyphicon.minus}
            whenClicked={async () =>
                HandleClickAsync(
                    allGoals,
                    gameIdentityGoal,
                    identity,
                    goalNamesLoggedToday
                )
            }
            displayAsBlock={false}
        />
    );
}

async function HandleClickAsync(
    allGoals: IGoal[],
    gameIdentityGoal: IGameIdentityGoal,
    identity: IGameIdentityDTO,
    goalNamesLoggedToday: string[]
) {
    await ClientDataProvider.DeleteRecordsAsync(
        `${resourceNameGameIdentityGoal}?id=eq.${gameIdentityGoal.id}`
    );

    const identityType = identity.iscombo ? `combo` : `identity`;
    
    const selectedGoalName = allGoals.find(
        (goal) => goal.id === gameIdentityGoal.goalid
    )!.name;

    toastr.success(
        `Removed the goal '${selectedGoalName}' from the ${identityType} '${identity.name}'`
    );

    await Data.Load.Single.ByStateTarget<IGameIdentityScoresState>(
        "gameIdentityScores"
    );

    var newIdentity: IGameIdentityDTO = {
        ...identity,
        goalNames: ArrayUtils.Exclude(identity.goalNames, selectedGoalName),
    };

    ShowIdentityDetails(newIdentity, goalNamesLoggedToday);
}
